<template>
  <div class="pagina ativa" id="paginaVendas">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><FilePlus2 :size="20" /> Lançar Venda</div>
    <div style="background:white;padding:30px;border-radius:12px;box-shadow:0 2px 8px rgba(0,0,0,0.1);max-width:800px;">

      <div class="venda-secao-label" style="display:flex;align-items:center;gap:6px;"><UserRound :size="13" /> Dados do Vendedor e Cliente</div>
      <p style="font-size:11px;color:#888;margin:-6px 0 8px;">Preencha uma vez — esses dados valem para todos os contratos lançados abaixo.</p>
      <div class="venda-grid">
        <div><label>VENDEDOR</label><input type="text" :value="sessao.nome" readonly /></div>
        <div><label>DATA VENDA</label><input type="date" v-model="cliente.dataVenda" /></div>
        <div><label>NOME CLIENTE</label><input type="text" v-model="cliente.nomeCliente" placeholder="Nome do cliente" /></div>
        <div><label>CPF / CNPJ</label><input type="text" v-model="cliente.cpf" @input="mascaraCpfCnpj" placeholder="CPF ou CNPJ" maxlength="18" /></div>
      </div>

      <div v-for="(ct, i) in contratos" :key="i" style="border:1.5px solid #e0e0e0;border-radius:10px;padding:16px 16px 4px;margin-top:20px;position:relative;">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
          <div style="display:flex;align-items:center;gap:6px;font-weight:bold;color:#4a5c2f;font-size:13px;"><FileText :size="14" /> Contrato {{ i + 1 }}</div>
          <button v-if="contratos.length > 1" type="button" @click="removerContrato(i)" style="display:inline-flex;align-items:center;gap:4px;margin:0;padding:4px 12px;font-size:11px;background:#fef2f2;color:#c0392b;border:1px solid #fca5a5;border-radius:6px;cursor:pointer;"><X :size="11" /> Remover</button>
        </div>

        <div class="venda-secao-label">Dados do Contrato</div>
        <div class="venda-grid">
          <div><label>NUMERO CONTRATO *</label><input type="text" v-model="ct.numeroContrato" placeholder="Ex: 8369431" /></div>
          <div>
            <label>NUMERO GRUPO *</label>
            <input type="text" v-model="ct.numeroGrupo" inputmode="numeric" placeholder="Ex: 9664" />
            <div style="display:flex;align-items:flex-start;gap:5px;font-size:11px;color:#8a6d1d;background:#fff8e1;border:1px solid #ffe082;border-radius:6px;padding:6px 8px;margin-top:4px;line-height:1.4;">
              <TriangleAlert :size="13" style="flex-shrink:0;margin-top:1px;" /> Digite só o número do grupo, sem zeros à esquerda. Na importação ele vem como <strong>0009664-01</strong> (grupo-cota); aqui lance <strong>9664</strong>.
            </div>
          </div>
          <div><label>NUMERO COTA</label><input type="text" v-model="ct.numeroCota" placeholder="Ex: 2826-00" /></div>
          <div>
            <label>BEM *</label>
            <select v-model="ct.bem" @change="filtrarTabelas(ct)">
              <option value="">Selecione...</option>
              <option>AUTOMOVEL</option><option>SERVICO E MOTO</option><option>PESADOS</option><option>IMOVEIS</option><option>IMOVEL ESTENDIDO</option>
            </select>
          </div>
          <div>
            <label>TABELA VENDA *</label>
            <select v-model="ct.tabelaVenda">
              <option value="">{{ ct.bem ? (tabelasFiltradasPara(ct).length ? 'Selecione...' : 'Nenhuma tabela para este BEM') : 'Selecione o BEM primeiro' }}</option>
              <option v-for="t in tabelasFiltradasPara(ct)" :key="t.linha" :value="t.tabela">{{ t.tabela }}</option>
            </select>
          </div>
          <div><label>DATA ALOCACAO</label><input type="date" v-model="ct.dataAlocacao" /></div>
          <div>
            <label>DIA VENCIMENTO</label>
            <select v-model="ct.dataVencimento">
              <option value="">Selecione...</option>
              <option value="10">Dia 10</option><option value="15">Dia 15</option><option value="20">Dia 20</option><option value="25">Dia 25</option>
            </select>
          </div>
          <div>
            <label>NUMERO PARTICIPANTE GRUPO</label>
            <select v-model="ct.numeroParticipante">
              <option value="">Selecione...</option>
              <option value="5000">5.000</option><option value="900">900</option><option value="600">600</option>
            </select>
          </div>
        </div>

        <div class="venda-secao-label" style="display:flex;align-items:center;gap:6px;"><Wallet :size="13" /> Financeiro</div>
        <div class="venda-grid">
          <div><label>VALOR (R$)</label><input type="text" v-model="ct.valor" @input="mascaraValor($event, ct)" placeholder="Ex: 120.000,00" /></div>
          <div>
            <label>LANCE % SOBRE CARTA</label>
            <select v-model="ct.lance">
              <option value="">Selecione...</option>
              <option value="Lance Livre">Lance Livre</option><option value="25">25%</option><option value="50">50%</option>
            </select>
          </div>
          <div style="grid-column:1/-1"><label>VALOR LIQUIDO DO CREDITO</label><input type="text" :value="valorLiquidoPara(ct)" readonly placeholder="Preencha valor e lance" style="background:#eef4e6;font-weight:bold;color:#2e3a18;" /></div>
        </div>

        <div class="venda-secao-label" style="display:flex;align-items:center;gap:6px;"><NotebookPen :size="13" /> Observação</div>
        <textarea v-model="ct.observacao" placeholder="Anotacoes sobre esta cota (opcional)..." style="width:100%;padding:10px;margin:4px 0 14px;border:1px solid #ccc;border-radius:5px;font-size:14px;height:52px;resize:vertical;"></textarea>
      </div>

      <button type="button" @click="adicionarContrato" style="margin:14px 0 0;padding:9px 16px;font-size:12px;background:#f8f9f6;color:#4a5c2f;border:1px dashed #aaa;width:100%;">+ Adicionar outro contrato para este cliente</button>

      <div style="max-width:220px;margin-top:16px;"><label>STATUS DA CARTA</label><select disabled><option>Ativa</option></select></div>

      <div style="margin-top:20px;">
        <button @click="salvar" style="width:100%;">{{ contratos.length > 1 ? 'SALVAR ' + contratos.length + ' VENDAS' : 'SALVAR VENDA' }}</button>
        <div class="status" :class="statusClasse">{{ statusMsg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, getSession } from '../api'
import { takePendingVenda } from '../crmHelpers'
import { FilePlus2, UserRound, FileText, X, TriangleAlert, Wallet, NotebookPen } from 'lucide-vue-next'

const CATEGORIA_PARA_BEM = { 'Veículo': 'AUTOMOVEL', 'Veiculo': 'AUTOMOVEL', 'Imóvel': 'IMOVEIS', 'Imovel': 'IMOVEIS' }

function formValorParaNumero(v) {
  return parseFloat((v || '').toString().replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) || 0
}

function contratoVazio() {
  return {
    numeroContrato: '', numeroGrupo: '', numeroCota: '', valor: '',
    bem: '', tabelaVenda: '', dataAlocacao: '', dataVencimento: '', lance: '',
    numeroParticipante: '', observacao: ''
  }
}

export default {
  name: 'PaginaVendas',
  components: { FilePlus2, UserRound, FileText, X, TriangleAlert, Wallet, NotebookPen },
  data() {
    return {
      sessao: getSession(),
      tabelas: [],
      cliente: { nomeCliente: '', cpf: '', dataVenda: '' },
      contratos: [contratoVazio()],
      statusMsg: '',
      statusClasse: ''
    }
  },
  created() {
    this.carregarTabelas()
    const pendente = takePendingVenda()
    if (pendente) {
      this.cliente.nomeCliente = pendente.nomeCliente || ''
      this.cliente.cpf = pendente.cpf || ''
      this.cliente.dataVenda = new Date().toISOString().substring(0, 10)
      this.contratos[0].valor = pendente.valor || ''
      this.contratos[0].bem = CATEGORIA_PARA_BEM[pendente.categoria] || ''
      this.contratos[0].observacao = pendente.observacao || ''
    }
  },
  methods: {
    tabelasFiltradasPara(ct) {
      if (!ct.bem) return []
      return this.tabelas.filter(t => t.bem === ct.bem)
    },
    valorLiquidoPara(ct) {
      const valor = formValorParaNumero(ct.valor)
      const lance = ct.lance
      const pct = (lance === '25' || lance === '50') ? parseFloat(lance) : null
      if (valor > 0 && pct !== null) {
        const liquido = valor - (valor * pct / 100)
        return 'R$ ' + liquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' (' + pct.toFixed(1) + '% de lance)'
      } else if (valor > 0 && lance === 'Lance Livre') {
        return 'A definir (Lance Livre)'
      }
      return ''
    },
    async carregarTabelas() {
      const r = await apiGet('tabela-comissao/listar')
      if (r.sucesso) this.tabelas = (r.tabela || []).filter(t => (t.status || '').toLowerCase().trim() !== 'inativo')
    },
    filtrarTabelas(ct) {
      ct.tabelaVenda = ''
    },
    adicionarContrato() {
      this.contratos.push(contratoVazio())
    },
    removerContrato(i) {
      if (this.contratos.length <= 1) return
      this.contratos.splice(i, 1)
    },
    mascaraCpfCnpj(e) {
      let v = e.target.value.replace(/\D/g, '')
      if (v.length <= 11) {
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      } else {
        v = v.replace(/^(\d{2})(\d)/, '$1.$2')
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')
        v = v.replace(/(\d{4})(\d)/, '$1-$2')
      }
      this.cliente.cpf = v
    },
    mascaraValor(e, ct) {
      let v = e.target.value.replace(/\D/g, '')
      if (!v) { ct.valor = ''; return }
      v = (parseInt(v) / 100).toFixed(2)
      v = v.replace('.', ',')
      v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      ct.valor = 'R$ ' + v
    },
    async salvar() {
      if (!this.cliente.nomeCliente || !this.cliente.dataVenda) {
        this.statusClasse = 'erro-msg'
        this.statusMsg = 'Preencha Nome do Cliente e Data da Venda.'
        return
      }
      for (let i = 0; i < this.contratos.length; i++) {
        const ct = this.contratos[i]
        if (!ct.numeroContrato || !ct.numeroGrupo || !ct.bem || !ct.tabelaVenda) {
          this.statusClasse = 'erro-msg'
          this.statusMsg = 'Contrato ' + (i + 1) + ': preencha Numero Contrato, Numero Grupo, BEM e Tabela.'
          return
        }
      }
      this.statusClasse = ''
      this.statusMsg = 'Salvando...'
      let sucesso = 0
      let erros = []
      for (const ct of this.contratos) {
        const body = {
          vendedor: this.sessao.nome,
          nomeCliente: this.cliente.nomeCliente,
          cpf: this.cliente.cpf,
          numeroContrato: ct.numeroContrato,
          numeroGrupo: ct.numeroGrupo,
          numeroCota: ct.numeroCota,
          valor: formValorParaNumero(ct.valor),
          bem: ct.bem,
          tabelaVenda: ct.tabelaVenda,
          dataAlocacao: ct.dataAlocacao,
          dataVenda: this.cliente.dataVenda,
          dataVencimento: ct.dataVencimento,
          lance: ct.lance,
          numeroParticipante: ct.numeroParticipante,
          status: 'Ativa',
          observacao: ct.observacao
        }
        try {
          const r = await apiPost('vendas/salvar', body)
          if (r.sucesso) sucesso++
          else erros.push('Contrato ' + ct.numeroContrato + ': ' + (r.mensagem || 'erro ao salvar'))
        } catch (e) {
          erros.push('Contrato ' + ct.numeroContrato + ': erro de conexao')
        }
      }
      if (erros.length === 0) {
        this.cliente = { nomeCliente: '', cpf: '', dataVenda: '' }
        this.contratos = [contratoVazio()]
        this.statusClasse = 'sucesso'
        const msgs = sucesso > 1
          ? [sucesso + ' VENDAS FECHADAS!', 'MANDOU BEM, ' + sucesso + ' DE UMA VEZ!']
          : ['VENDA FECHADA!', 'MAIS UMA!', 'BORA QUE BORA!', 'SHOW DE BOLA!', 'VENDEDOR RACA!']
        this.statusMsg = msgs[Math.floor(Math.random() * msgs.length)]
        setTimeout(() => { this.statusMsg = ''; this.statusClasse = '' }, 4000)
      } else {
        this.statusClasse = 'erro-msg'
        this.statusMsg = (sucesso > 0 ? sucesso + ' salva(s). ' : '') + erros.join(' | ')
      }
    }
  }
}
</script>
